import { Pipe, PipeTransform } from '@angular/core';

/**
 * Determines the appStore based on the passed appId parameter.
 *
 */

@Pipe({
  name: 'appStoreMap',
  pure: true
})
export class AppStoreMapPipe implements PipeTransform {
  constructor() {}

  transform(appId: string): string {
    return isNaN(parseFloat(appId)) ? 'android' : 'ios';
  }
}
